import * as Comp from './styles'
import type { TScrimProps } from './types'

const ScrimRoot = ({ children, testID }: TScrimProps) => {
  return (
    <Comp.ScrimContainer testID={testID}>
      <Comp.ScrimBackground />
      {children}
    </Comp.ScrimContainer>
  )
}

export const Scrim = {
  Root: ScrimRoot,
}

export type { TScrimProps }
